module.exports = __webpack_public_path__ + "wf.svg?c942b078f06fd4e28d7a513cbcceda65";